module.exports = __webpack_public_path__ + "img/icon_balance_all_type.28624c7e.svg";